<template>
    <div style="height: 100vh;">
        <div style="">
            <a-card title="" style="border-radius: 20px;" :bordered="false" >
                <div class="actions">
                    <a-button type="link" @click="redirectUrl" style="font-size:14px;text-decoration:none;line-height:30px;color:#111827;display:flex">
                        <p style="font-size: 10px;">
                            <a-icon type="arrow-left" />
                        </p> 
                        <p style="margin-left: 10px; font-size: 15px;">Go Back To Products</p>
                        
                    </a-button>
                    <!-- <a-button @click="showAddProductModal" style="height:38px; border-raduis:5px; background: #ffffff" icon="plus">
                        Add Multiple Products
                    </a-button> -->
                    <div style="display:flex; justify-content: space-around;">
                        <!-- <a-button @click="showLowStockPage" style="height:38px;border-raduis:5px; background: #418a49;color:#fff" >
                        Replenish Low Stock
                        <span class="px-2"> <a-badge :count="balLessThan20.length" show-zero :number-style="{ backgroundColor: '#52c41a' }"/></span>
                        </a-button> -->
                    
                    
                        <!-- <a-button @click="showOutOfStockPage" style="height:38px;border-raduis:5px; background: #418a49;color:#fff" > -->
                    
                        <a-button @click="showAddProductPage" style="border-raduis:6px; background: #fff;color:#0F3659; margin-right:10px;" >
                         Save as draft
                        </a-button>

                        <a-button  style="border-raduis:6px; background: #fff;color:#0F3659"  >
                        Publish product
                        </a-button> 
                    </div>
                </div>
                
                <div style="margin-top: 30px; display: flex; justify-content: center; align-items: center; margin-bottom: 30px;">
                    <div>
                        <h3 style="margin-bottom: 20px;">Create new product</h3>
                        <a-collapse v-model="activeKey" :bordered="false" :expand-icon-position="'right'">
                        <a-collapse-panel key="0" :disabled="showProductCategoryTab" header="Set Product Category">
                        <SetProductCategory/>
                        </a-collapse-panel>
                        <a-collapse-panel key="1" :disabled="showProductTab" header="Input Product Details">
                          <InputProductDetails/>
                        </a-collapse-panel>
                        <a-collapse-panel key="2" :disabled="showProductImageTab" header="Add Product Image">
                            <AddProductImage/>
                        </a-collapse-panel>
                        <a-collapse-panel key="3" :disabled="showInventoryTab" header="Add Inventory Details">
                            <AddInventoryDetails/>
                        </a-collapse-panel>
                        </a-collapse>
                    </div>
                </div>
            </a-card>
        </div>
    </div>
</template>

<script>

import { mapActions, mapGetters } from 'vuex';
import SetProductCategory from './SetProductCategory.vue';
import InputProductDetails  from './InputProductDetails.vue';
import AddProductImage from './AddProductImage.vue';
import AddInventoryDetails from './AddInventoryDetails.vue';

    export default {
        name: 'AddNewProduct',
        components: {
            SetProductCategory,
            InputProductDetails,
            AddProductImage,
            AddInventoryDetails
        },
        data() {
            return {
                current: 0,
                activeKey: ['0'],
                showProductCategoryTab: false,
                showProductTab: true,
                showProductImageTab: true,
                showInventoryTab: true
            };
        },
         computed: {
            ...mapGetters(['getStepCount'])
        },
        methods:{
             ...mapActions(['setStepCount','setProductGroupInfo','setProductDetailsInfo']),
            // onChange(current) {
            //     // console.log('onChange:', current);
            //     this.current = current;
            //     if(current === 0){
            //         this.setStepCount(0)
            //         this.$router.push(`/new-product`).catch(()=>{});
            //     }else if(current === 1){
            //         this.setStepCount(1)
            //         this.$router.push(`/product-details`).catch(()=>{});
            //     }
            //     else if(current === 2){
            //         this.setStepCount(2)
            //         this.$router.push(`/product-image`).catch(()=>{});
            //     }else if(current === 3){
            //         this.setStepCount(3)
            //         this.$router.push(`/inventory-details`).catch(()=>{});
            //     }
            // },
         
            redirectUrl(){
                this.setStepCount(0)
                this.setProductGroupInfo({})
                this.setProductDetailsInfo({})
                this.$router.push(`/inventory`).catch(()=>{});
            },
            showSuccessAlert(message) {
                this.$notification['success']({
                    message: message,
                });
            },
            showErrorAlert(message) {
                this.$notification['error']({
                    message: message
                });
            },
          
        },
        created(){
            this.$watch(
                () => this.$store.getters.getStepCount,
                (newValue) => {
                    if(newValue){
                        this.current = this.getStepCount
                        if(this.current === 0){
                            this.setStepCount(0)
                            this.activeKey = ['0'];
                            this.showProductCategoryTab = false
                            this.showProductTab = true
                            this.showProductImageTab = true
                            this.showInventoryTab =  true
                        }else if(this.current === 1){
                            this.setStepCount(1)
                            this.activeKey = ['1'];
                            this.showProductCategoryTab = true
                            this.showProductTab = false
                            this.showProductImageTab = true
                            this.showInventoryTab =  true
                        }
                        else if(this.current === 2){
                            this.setStepCount(2)
                            this.activeKey = ['2'];
                            this.showProductCategoryTab = true
                            this.showProductTab = true
                            this.showProductImageTab = false
                            this.showInventoryTab =  true
                        }else if(this.current === 3){
                            this.setStepCount(3)
                            this.activeKey = ['3'];
                             this.showProductCategoryTab = true
                            this.showProductTab = true
                            this.showProductImageTab = true
                            this.showInventoryTab =  false
                        }
                    }
                }
            );
        },
    }
</script>

<style scoped>
.actions{
    display: flex;
    justify-content: space-between;
}
.img_size{
    max-width: 56px;
    max-height: 55px;
}

.rightSideinputText{
    width: 336px;
    /* height: 50px; */
    border-radius: 5px;
}
.descInputText{
    /* height: 50px; */
    width: 336px;
    border-radius: 5px;
}
.dropdownItem{
    width: 336px;
    border-radius: 5px;
}

.selecInput{
    width: 336px;
    /* height: 50px; */
    border-radius: 5px;
}
.ant-upload.ant-upload-drag p.ant-upload-drag-icon .anticon {
    color: #98c14b;
    font-size: 48px;
}

.ant-layout-sider{
    background: #FFFFFF;
}
.slider >>> .ant-steps-item-process .ant-steps-item-icon {
    background: #418a49;
}
.slider >>> .ant-steps-item-process .ant-steps-item-icon {
    border-color: #418a49;
}
.slider >>> .ant-steps-item-process .ant-steps-item-icon:hover {
    color: #418a49;
}

.slider >>> .anticon {
    vertical-align: 2px;
}

.slider >>> .ant-steps-item-finish .ant-steps-item-icon {
    background-color: #fff;
    border-color: #418a49;
}
.slider >>> .ant-steps-item-finish .ant-steps-item-icon > .ant-steps-icon {
    color: #418a49;
}
.slider >>> .ant-steps-item-finish > .ant-steps-item-container > .ant-steps-item-tail::after {
    background-color: #418a49;
}
.slider {
    flex: none !important; 
    max-width: none !important;
    min-width: none !important;
    width: 250px !important;
}

.spinner >>> .ant-spin-dot-item {
    background-color: #418a49;
}

.upload-list-inline >>> .ant-upload-list-item {
  float: left;
  width: 200px;
  margin-right: 8px;
}
.upload-list-inline >>> .ant-upload-animate-enter {
  animation-name: uploadAnimateInlineIn;
}
.upload-list-inline >>> .ant-upload-animate-leave {
  animation-name: uploadAnimateInlineOut;
}

.ant-collapse-borderless {
    background-color: #fff;
    border: 0;
}
</style>

